/*
 * Copyright (c) Nexign, JSC, 2020.
 */
/**
 * Settings profile component to handle change secret question
 *
 * @author Anton Panasenko
 * @version 1.4.0
 * @since 1.3.0
 */

import { LinkBlock } from '../../../../../components/common';
import { IPageSettingsTranslation } from '../../../../../modules/internationalization/types/pages/pageSettings';
import { IModalOpenPayload } from '../../../../../modules/modal/types/modalActionTypes';
import { PageSettingsHeaderStyled } from '../../styled/PageSettingsStyled';
import { ESettingsProfileComponents } from '../settingsProfileConstants';
import { ISettingsProfileMetaQuestion, ISettingsProfileResetParamsActionPayload } from '../settingsProfileTypes';
import {
    SettingsProfileLabelStyled,
    SettingsProfileQuestionCurrentContainerStyled,
    SettingsProfileQuestionCurrentQuestionStyled,
} from '../styled/SettingsProfileStyled';
import SettingsProfileQuestionModal from './SettingsProfileQuestionModal';

export interface ISettingsProfileQuestionProps {
    meta: ISettingsProfileMetaQuestion;
    openModal: (payload: IModalOpenPayload) => void;
    resetParams: (payload: ISettingsProfileResetParamsActionPayload) => void;
    settingsTranslation: IPageSettingsTranslation;
}

export const SettingsProfileQuestion = (props: ISettingsProfileQuestionProps) => {
    const { question: translationQuestion } = props.settingsTranslation.profile;

    const resetQuestionParams = () => {
        props.resetParams({ params: [ESettingsProfileComponents.QUESTION] })
    }

    const handleLinkClick = () => {
        props.openModal({
            render: props => <SettingsProfileQuestionModal
                onClose={() => {
                    props.onCloseModal();
                    resetQuestionParams();
                }}
            />,
        })
    }

    return (
        <SettingsProfileQuestionCurrentContainerStyled>
            <PageSettingsHeaderStyled>
                {translationQuestion.header}
            </PageSettingsHeaderStyled>
            <SettingsProfileLabelStyled>
                {translationQuestion.labelCurrent}
            </SettingsProfileLabelStyled>
            <SettingsProfileQuestionCurrentQuestionStyled data-name='currentQuestionPage'>
                {props.meta.currentQuestion}
            </SettingsProfileQuestionCurrentQuestionStyled>
            <LinkBlock dataName='changeQuestionLink' onClick={handleLinkClick}>
                {translationQuestion.link}
            </LinkBlock>
        </SettingsProfileQuestionCurrentContainerStyled>
    )
};
